import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const invoiceNinja = defineConnector({
  identifier: "invoiceNinja",
  name: "Invoice Ninja",
  tagLine: "Invoicing and billing platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://invoicing\\.co/.*",
  auth: (app) =>
    headerAuth([{ name: "X-API-TOKEN", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Enter your Invoice Ninja instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "invoicing.co",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Use invoicing.co for hosted, or your self-hosted domain.",
        },
      ],
    },
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Invoice Ninja, go to **Settings › Account Management › API Tokens** and create a new token. See the [API docs](https://invoiceninja.github.io/) for details.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/ping`,
  },
});
